import React from 'react';
import styled from 'styled-components';
export const ProgressBarBox = styled.div `
  height: ${(props) => props.height};
  background-color: ${(props) => props.bgColor};
  border-radius: 4px;
`;
export const Progress = styled.div `
  background-color: ${(props) => props.barColor};
  height: 100%;
  border-radius: 4px;
  width: ${(props) => props.progress}%;
`;
const ProgressBar = ({ progress, bgColor, barColor, height, className, progressClassName, }) => (React.createElement(ProgressBarBox, { id: "progress", bgColor: bgColor, height: height || '3px', className: className || 'ProgressBar' },
    React.createElement(Progress, { className: progressClassName || '', progress: progress, barColor: barColor })));
export default ProgressBar;
